import { render, staticRenderFns } from "./DatetimeWidget.vue?vue&type=template&id=5ba06dc4&scoped=true&"
import script from "./DatetimeWidget.vue?vue&type=script&lang=js&"
export * from "./DatetimeWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba06dc4",
  null
  
)

export default component.exports